import { Component, OnInit, Inject } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import {
  caseListTemplate,
  CaseListComponent,
  Filter,
  ResourceDefinition,
  BreadcrumbService,
  FlashMessageService,
  ResourceService,
  CaseConfig,
  Yield,
  InputType,
  AuthService,
  FilterService
} from '@case-app/angular-library'

import { marketDefinition } from '../market.definition'
import { marketYields } from '../market.yields'

@Component({ template: caseListTemplate })
export class MarketListComponent extends CaseListComponent implements OnInit {
  definition: ResourceDefinition = marketDefinition
  yields: Yield[] = marketYields

  filters: Filter[] = [
    {
      label: `Dates d'activité du marché`,
      properties: {
        dateFrom: 'activeDateFrom',
        dateTo: 'activeDateTo'
      },
      inputType: InputType.DateRange,
      className: 'is-12'
    }
  ]

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService,
    filterService: FilterService,
    authService: AuthService,
    @Inject('CASE_CONFIG_TOKEN') config: CaseConfig
  ) {
    super(
      router,
      activatedRoute,
      breadcrumbService,
      resourceService,
      flashMessageService,
      authService,
      filterService,
      config
    )
  }

  ngOnInit() {
    this.initListView()
  }
}
